// @flow strict

import * as React from 'react';

export type sponsorshipContext = {|
  tripId?: number,
|};

const initialContext: sponsorshipContext = {
  tripId: 0,
};

const SponsorshipTrackingContext: React.Context<sponsorshipContext> = React.createContext(
  initialContext,
);

export default SponsorshipTrackingContext;
